import axiosClient from "./axiosClient";

export const getPlanInfo = (product, companyId) => {
    return axiosClient.get(`/companyPlan/upgrade?companyId=${companyId}&operationId=${product}`)
}